import React from 'react';

/**
 * Less than ideal solution:
 * This component is used to measure height of window + url bar on mobile devices.
 * Should have no effect on desktop with mobile emulator.
 * See useFloatingPanelAnchors() for usage
 */

type MobileControlHeightProps = {};

const MobileClientHeight = React.forwardRef<
  HTMLDivElement,
  MobileControlHeightProps
>((_, ref) => (
    <div
      ref={ref}
      style={{ height: '100vh', width: 0, position: 'absolute' }}
    ></div>
  ));

export default MobileClientHeight;
